import { InvoiceV2Output } from '@allocab/allocab-invoice-service-types';
import { useMutation } from '@tanstack/react-query';
import { saveAs } from 'file-saver';

import { constants } from '../constants';
import { getFreshTokens } from '../services/network/Api';
import { APIError } from '../services/network/types';
import { t } from '../services/translation/translation';

const downloadInvoiceV2 = async (invoice: InvoiceV2Output) => {
  const tokens = await getFreshTokens();

  const response = await fetch(`${constants.driverApi}/v2/invoice/${invoice.id}/pdf`, {
    method: 'GET',
    headers: {
      responseType: 'blob',
      ...(tokens ? { Authorization: `Bearer ${tokens.accessToken}` } : {}),
    },
  });

  if (!response.ok) {
    throw { type: 'api', message: t('network.server-error') } satisfies APIError;
  }

  const blob = await response.blob();

  // Download the file
  saveAs(blob, `${invoice.invoiceNumber}.pdf`);
};

export const useDownloadInvoiceV2 = () =>
  useMutation<void, unknown, InvoiceV2Output, InvoiceV2Output>({
    mutationFn: downloadInvoiceV2,
  });
